module.exports = __webpack_public_path__ + "static/media/SDFSA_7-509w.475d208b.webp";